<template>
    <div class="battery-wrapper">
        <span class="power">{{power}}%</span>
        <div class="battery">
            <div class="main" :style="{borderColor: power <= 20 ? 'red' : '#55ba61'}">
                <div class="wrapper" :style="styles"></div>
            </div>
            <div class="head" :style="{backgroundColor: power <= 20 ? 'red' : '#55ba61'}"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "battery",

    props: {
        power: {
            type: Number,
            required: true
        }
    },

    computed: {
        styles() {
            return {
                backgroundColor: this.power <= 20 ? "red" : "#55ba61",
                width: `${this.power}%`
            };
        }
    }
};
</script>

<style scoped>
.battery-wrapper {
    height: 50%;
    min-height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.power {
    font-size: 16px;
    color: rgba(72, 72, 72, 1);
}

.battery {
    height: 50%;
    width: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.main {
    height: 100%;
    width: calc(100% - 10px);
    border: 2px solid #55ba61;
    border-radius: 6px;
    padding: 2px;
}

.wrapper {
    height: 100%;
}

.head {
    height: 60%;
    width: 4px;
    background: #55ba61;
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
}
</style>